import { CloseIconWithoutCircle } from '@va/icons';
import { NotificationDismissible, NotificationItem } from './types';

function shouldShowDismissButton(dismissible?: NotificationDismissible) {
  if (dismissible === false || dismissible === 'none') return false;
  return dismissible === true || dismissible === 'both' || dismissible === 'button';
}

function shouldDismissOnClick(dismissible?: NotificationDismissible) {
  if (dismissible === false || dismissible === 'none') return false;
  return dismissible === true || dismissible === 'both' || dismissible === 'click';
}

export const NotificationContent = ({
  dismiss,
  notification,
}: {
  notification: NotificationItem;
  dismiss: () => void;
}) => {
  const dismissOnClick = shouldDismissOnClick(notification.dismissible);
  const showDismissButton = shouldShowDismissButton(notification.dismissible);

  return (
    <div
      className='min-h-[10rem] w-[34rem] rounded-l-15 p-6 text-white opacity-90 notification-visible'
      onClick={dismissOnClick ? dismiss : undefined}
    >
      {showDismissButton && (
        <button
          className='absolute right-4 top-4 h-5 w-5 cursor-pointer bg-transparent'
          onClick={(e) => {
            e.stopPropagation();
            dismiss();
          }}
          type='button'
        >
          <CloseIconWithoutCircle />
        </button>
      )}
      {notification.title && <h4 className='mb-2 text-sm font-bold'>{notification.title}</h4>}
      {notification.children && <div>{notification.children}</div>}
    </div>
  );
};
